import { selector } from "recoil"
import { canDeleteAccount, CanDeleteAccountResponse } from "src/aws/customAPI"
import { tokensState } from "src/recoil/atoms/authorization/tokensState"
import { accountRequestIdDeleteState } from "src/recoil/atoms/account/accountRequestIdDeleteState"

export const canDeleteAccountSelector = selector<CanDeleteAccountResponse | undefined>({
  key: "selectors/account/canDeleteAccountSelector",
  get: async ({ get }) => {
    get(accountRequestIdDeleteState)
    const tokens = get(tokensState)
    if (tokens == null) return undefined
    const response = await canDeleteAccount(tokens.accessToken).then((res) => res.data)
    if (response == null) return
    return response
  },
})
